import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Clock3, Phone } from "lucide-react";
import { EASE, PORTRAIT_IMAGE } from "./data";

function HeroTitle() {
  const lines = [
    <>Care that helps</>,
    <>you feel <em>like</em></>,
    <><em>yourself</em> again.</>,
  ];
  return (
    <h1 data-testid="hero-title">
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: 0.2 + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}

export function Hero({ onBook }) {
  const heroRef = useRef(null);
  const { scrollYProgress: heroProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const heroImageY = useTransform(heroProgress, [0, 1], [0, 90]);
  const heroCardY = useTransform(heroProgress, [0, 1], [0, -60]);
  return (
    <section className="hero container" ref={heroRef}>
      <div className="hero-copy">
        <motion.div className="hero-kicker" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1, ease: EASE }}><span className="pulse-dot" /> Expert urology care at Hitec City &amp; Gachibowli, Hyderabad</motion.div>
        <HeroTitle />
        <motion.p className="hero-text" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.75, ease: EASE }}><strong>Dr. Sreeniketh Reddy</strong> — Consultant Urologist, Andrologist and Robotic Surgeon.</motion.p>
        <motion.div className="hero-actions" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.9, ease: EASE }}>
          <button className="button button-primary" data-testid="hero-appointment-button" onClick={onBook}>Request an appointment <ArrowRight size={18} /></button>
          <a className="text-link" data-testid="hero-call-link" href="tel:7780793371"><Phone size={17} /> Call 7780793371</a>
        </motion.div>
      </div>
      <div className="hero-visual">
        <motion.div className="image-frame" style={{ y: heroImageY }} initial={{ opacity: 0, scale: 1.06 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.4, delay: 0.35, ease: EASE }}><img data-testid="hero-doctor-image" src={PORTRAIT_IMAGE} alt="Dr. Sreeniketh Reddy, urologist in Hitec City Hyderabad — kidney stone specialist, prostate expert and circumcision specialist" /></motion.div>
        <motion.div className="availability-card" style={{ y: heroCardY }} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 1.05, ease: EASE }}><span className="availability-icon"><Clock3 size={18} /></span><span><b>OPD appointments at</b><small>MEDICOVER, Hitec City and LUX hospital</small></span></motion.div>
      </div>
    </section>
  );
}
